const pll = {
    prevSlideMessage: 'Aller à la slide précédente',
    nextSlideMessage: 'Aller à la slide suivante',
    firstSlideMessage: 'C\'est la première slide',
    lastSlideMessage: 'C\'est la dernière slide',
    paginationBulletMessage: 'Aller à la slide {{index}}'
};

export default pll;